import { Component, h, Host, Prop, Element, Listen } from "@stencil/core";

@Component({
    tag: "ux-iws-icon-label-toggle",
    styleUrl: "icon-label-toggle.scss",
    shadow: true,
})
export class IconLabelToggle {
    @Element() element: HTMLUxIwsIconLabelToggleElement;

    /** Label */
    @Prop() label: string = "";
    /** toggle between active and inactive styles */
    @Prop() isActive: boolean = false;

    private targetClass = "ux-static-filter__item--filtered";

    @Listen("uxStaticFilter", { target: "window" })
    handleUxStaticFilterEvent() {
        if (!this.element.hasAttribute("data-ux-static-filter")) {
            return;
        }
        if (this.element.classList.contains(this.targetClass)) {
            this.isActive = false;
        } else {
            this.isActive = true;
        }
    }

    render() {
        const tooltipSlotElement = this.element.querySelector(
            '[slot="tooltip-content"]'
        );

        return (
            <Host active={this.isActive}>
                <ux-icon
                    name={this.isActive ? "checkmark" : "cross"}
                    weight="bold"
                ></ux-icon>
                <span class="label">{this.label}</span>
                {tooltipSlotElement ? (
                    <div class="tooltip">
                        <ux-icon name="info"></ux-icon>
                        <ux-tooltip tooltip-target="ux-icon[name='info']">
                            <slot name="tooltip-content"></slot>
                        </ux-tooltip>
                    </div>
                ) : null}
            </Host>
        );
    }
}
